import { itx } from "../../translationItx/itx";
import { channelTypeInfo } from "../../models/ChannelType";
import { SequenceStep, enumActions } from "../Guide";
import { ToDoItem } from "../ToDoItem";

// ContextMenuLables.addFloors
function sequence(type: string, lastToDoItem?: ToDoItem): Array<SequenceStep> {
  return [
    {
      id: () => {
        return `tv-${state.addresses.id}`;
      },
      action: enumActions.click,
    },
    {
      id: () => {
        return [`tv-${state.addresses.id}`, "treeViewModel_generateAdresses"]; // no itx
      },
      action: enumActions.click,
    },
    {
      action: enumActions.call,
      subSequence: () => {
        let seq = new Array<SequenceStep>();
        let waiting = true;
        state.allDevices().forEach((dev) => {
          if (!channelTypeInfo(dev.channelType).isSupply && !dev.template) {
            waiting = false;
          }
        });
        if (!waiting) {
          seq.push(
            {
              action: enumActions.wait,
            },

            {
              id: () => {
                return ["BaseDialog_ok"];
              },
              action: enumActions.click,
            },
          );
        }
        seq.push(
          // problems with waitFor sync
          // {
          //   action: enumActions.waitForSync,
          //   waitId: "knxAdressesGenerated",
          // },
          {
            action: enumActions.wait,
          },
          {
            id: () => {
              return ["BaseDialog_ok"];
            },
            action: enumActions.click,
          },
          {
            action: enumActions.explain,
            text: itx("ToDoItemLine.groupAdressesGenerated"),
          },
        );
        return seq;
      },
    },

    // {
    //   id: `BaseDialog_ok`,
    //   action: enumActions.click,
    // }
  ];
}

export default sequence;
